// 1_utils/smart_touch_click.js
// Exposes window.NAT.utils.addSmartTouchClickListener(element, handler): attaches a
// click handler meant to also distinguish taps from touch events. NOTE: in the
// legacy code the touchstart/touchend branch was commented out, so `touched` is
// never set and this currently behaves as a plain click listener — behavior kept.

window.NAT = window.NAT || {};
window.NAT.utils = window.NAT.utils || {};

window.NAT.utils.addSmartTouchClickListener = function addSmartTouchClickListener(element, handler) {
	let touched = false;

	element.addEventListener("click", function (e) {
		if (touched) {
			// Click after touch, skip
			touched = false;
			return;
		}
		handler(e);
	});
};
